import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { UseFormReturn } from "react-hook-form";
import { ReservationFormData } from "@/hooks/useReservationForm";
import { DateRangePicker } from "@/components/DateRangePicker";

interface FormFieldsProps {
  form: UseFormReturn<ReservationFormData>;
  dateDebut?: Date;
  dateFin?: Date;
  onDateDebutChange: (date: Date | undefined) => void;
  onDateFinChange: (date: Date | undefined) => void;
}

export const FormFields = ({ form, dateDebut, dateFin, onDateDebutChange, onDateFinChange }: FormFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label className="text-sm font-medium mb-2">Nom complet *</Label>
          <Input 
            placeholder="Votre nom et prénom"
            {...form.register("name")}
          />
          {form.formState.errors.name && (
            <p className="text-sm text-destructive mt-1">{form.formState.errors.name.message}</p>
          )}
        </div>
        <div>
          <Label className="text-sm font-medium mb-2">Téléphone *</Label>
          <Input 
            placeholder="Votre numéro de téléphone"
            {...form.register("phone")}
          />
          {form.formState.errors.phone && (
            <p className="text-sm text-destructive mt-1">{form.formState.errors.phone.message}</p>
          )}
        </div>
      </div>
      
      <div>
        <Label className="text-sm font-medium mb-2">Email *</Label>
        <Input 
          type="email" 
          placeholder="votre.email@exemple.com"
          {...form.register("email")}
        />
        {form.formState.errors.email && (
          <p className="text-sm text-destructive mt-1">{form.formState.errors.email.message}</p>
        )}
      </div>

      <DateRangePicker
        dateDebut={dateDebut}
        dateFin={dateFin}
        onDateDebutChange={onDateDebutChange}
        onDateFinChange={onDateFinChange}
      />
      {form.formState.errors.dateDebut && (
        <p className="text-sm text-destructive">{form.formState.errors.dateDebut.message}</p>
      )}
      {form.formState.errors.dateFin && (
        <p className="text-sm text-destructive">{form.formState.errors.dateFin.message}</p>
      )}

      <div>
        <Label className="text-sm font-medium mb-2">Message complémentaire</Label>
        <Textarea 
          placeholder="Précisions sur votre événement, questions spéciales..." 
          rows={4}
          {...form.register("message")}
        />
      </div>
    </>
  );
};
